import React from "react";
import { Grid, Box, Typography, Button as MUIButton } from "@mui/material";


const BetslipHeader = ({ betslipLength, onClearAll }) => (
  <Grid container alignItems="center" spacing={2}>
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ width: "100%" }}
    >
      <Grid item xs={2} lg={2} className="col-2">
        <Box
          className="mainbet"
          sx={{
            border: "2px solid #C02640",
            color: "#C02640",
            borderRadius: "50%",
            height: 30,
            width: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <b>{betslipLength}</b>
        </Box>

      </Grid>

      <Grid item xs={7} lg={7} md={7} className="col-7">
        <Typography className="betslip-heading" variant="subtitle1">
          Team Selection
        </Typography>
      </Grid>

      <Grid item xs={3} lg={3} onClick={onClearAll} className="col-3">
        <MUIButton
          className="clear_a"
          variant="text"
          size="medium"
          sx={{ textTransform: "none", p: 0, minWidth: 0, fontWeight: "500" }}
        >
          Clear all
        </MUIButton>
      </Grid>
    </Box>
  </Grid>
);

export default BetslipHeader;